import { toastify } from "../../../../helpers/toast/toastify";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ConnectedExchange from "./ConnectedExchange";
import "./ConnectExchange.css";
import "../CommunityName/CommunityName.css";
import Copy from "../../../../assets/images/Copy.svg";
import crossBlack from "../../../../assets/images/onboardingImages/crossBlack.svg";
import dropdownAngle from "../../../../assets/images/dropdownAngle.svg";
import FloatingTextFiled from "../../../sharedPages/CommonComponents/FloatingTextFiled/FloatingTextFiled";
import TradeMarketSegment from "../../../sharedPages/CommonComponents/TradeMarketSegment/TradeMarketSegment";
import InfoPopup from "../../../sharedPages/CommonComponents/InfoPopup/InfoPopup";
import longArrow from "../../../../assets/images/onboardingImages/longArrow.svg";
import Modal from "react-bootstrap/Modal";
import useApi from "../../../../helpers/apiHelper/requestHelper";
import {
  redirectToBinanceOAuth,
  redirectToBybitOAuth,
} from "../../../../helpers/exchangeOAuth";
import { useSelector, useDispatch } from "react-redux";
import CloseModal from "../../OnboardingCL/CreateSubscription/CloseModal";
import BubbleSvgButton from "../../../sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";
import { globalAllLeaderCommunities } from "../../../../store/globalstore";
import { useAtom } from "jotai";
import { setRefetchSpecificUser } from "../../../../redux/multicommunity/multicommunity.js";
import { resetOnBoardingStartContext, storeUser } from "../../../../redux/users/usersSlice.js";

const ENV = window.location.hostname.split(".")[0] === "my" ? "prod" : "dev";

const ConnectExchange = () => {
  const [warn, setWarn] = useState(false);
  const [allLeaderCommunities, _] = useAtom(globalAllLeaderCommunities);
  const [credentials, setCredentials] = useState({
    apiKey: "",
    exchange: "",
    secretKey: "",
  });

  const [formErrors, setFormErrors] = useState({
    apiKey: false,
    secretKey: false,
  });

  const [isApiKeySelected, setisApiKeySelected] = useState(false);
  const [tradeMarketType, setTradeMarketType] = useState("both");
  const [isConnected, setIsConnected] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState("Select Exchange");
  const [show, setShow] = useState(true);
  const { user } = useSelector((state) => state.user);
  const subscription = user?.verifiedmyTrade?.subscription;
  const hasActiveSubscription =
    subscription?.active && subscription.originalName;
  const [updateVerifyStatus, setUpdateVerifyStatus] = useState(false);
  const dispatch = useDispatch();
  const [previousCredentials, setPreviousCredentials] = useState(false);
  const api = useApi();
  const buttonRef = useRef(null);
  const modalBodyRef = useRef(null);
  const tradeMarketRef = useRef(null);
  const onBoardingStartContext = useSelector(
    (state) => state.user?.onBoardingStartContext
  );
  // const [nextButtonText,setNextButtonText]=useState(previousCredentials?.apiKey?.includes("****") ||
  //  previousCredentials?.secretKey?.includes("****")
  //   ? "Use Same API Keys"
  //   : "NEXT")
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  const [otherCommunityOptions, setOtherCommunityOptions] = useState(location?.state?.otherCommunityOptions||[]);
  const [useOldCredentials, setOldCredentials] = useState(null);
  const[previousCommunityConnected,setPreviousCommunityConnected]=useState(location?.state?.previousCommunityConnected||false);

  useEffect(() => {
    if (!isApiKeySelected) return;

    const scrollExpandedFieldsIntoView = () => {
      const scroller = modalBodyRef.current;
      const target = tradeMarketRef.current;

      if (scroller && scroller.scrollHeight > scroller.clientHeight + 1) {
        scroller.scrollTo({ top: scroller.scrollHeight, behavior: "smooth" });
      }

      // Always reveal the new fields — covers cases where the outer
      // .modal / viewport is the scroll container, not the body.
      target?.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest",
      });
    };

    const timers = [50, 180, 400].map((ms) =>
      window.setTimeout(scrollExpandedFieldsIntoView, ms)
    );
    return () => timers.forEach((id) => window.clearTimeout(id));
  }, [isApiKeySelected, selectedOption]);

  const isOnBoardingComplete =
  user?.onboarding?.isCommunityCreated &&
  user?.onboarding?.connect &&
  user?.onboarding?.payment &&
  user?.onboarding?.subscribed &&
  user?.onboarding?.isVerified;

  const navigateAfterOnboardingConnection = (permissionType) => {
    const market =
      permissionType ||
      tradeMarketType ||
      localStorage.getItem("permissionType") ||
      "both";
    if (market === "spot" || market === "both") {
      navigate("/leader/onboarding/spotCoin", { replace: true });
      return;
    }
    navigate("/leader/onboarding/subscription", { replace: true });
  };

  useEffect(()=>{
    if((isOnBoardingComplete&&user?.leaderCommunity&&location.pathname==="/leader/onboarding/connection")||(!user?.leaderCommunity&&location.pathname==="/leader/onboarding/connection")){
      navigate("/leader/dashboard", { replace: true });
      return;
     }
  },[])
  
  useEffect(() => {
    async function updateVerifyStatusBackend() {
      if (updateVerifyStatus && !user?.verifiedmyTrade.connecct) {
        const response = await api("post", "/users/updateVerifMyTradeStatus", {
          status: true,
        });
       const responseUser = await api("get", "users/index");
        if (responseUser?.status) {
          const { data } = responseUser;
          if (dispatch && storeUser) dispatch(storeUser(data));
          if (data?.token) localStorage.setItem("token", data.token);
        }
        navigate("/leader/verifymyTrade/payment", { replace: true });
        setUpdateVerifyStatus(false);
      }
    }
    updateVerifyStatusBackend();
  }, [updateVerifyStatus]);

  const connectManually = async ({ apiKey, secretKey, exchange }) => {
    try {
      const response = await api("post", "binanceCredentials/create", {
        apiKey,
        exchange,
        secretKey,
        permissionType: tradeMarketType,
        verifyMyTrade: window.location.pathname.includes("verifymyTrade"),
        onboardingConnection: window.location.pathname.includes(
          "onboarding/connection"
        ),
      });

      const { message, status } = response || {};
      if (status) {
        setIsConnected(true);
        const responseUser = await api("get", "users/index");

        if (responseUser?.status) {
          const { data } = responseUser;
          if (dispatch && storeUser) dispatch(storeUser(data));
          if (data?.token) localStorage.setItem("token", data.token);
          // return data;
        }else{

          dispatch(setRefetchSpecificUser(true));
        }
        return setTimeout(() => {
          setIsConnected(false);
          if (window.location.pathname.includes("verifymyTrade"))
            navigate("/leader/verifymyTrade/payment", { replace: true });
          else navigateAfterOnboardingConnection(tradeMarketType);
        }, 3000);
      }
      if (
        message ===
        "Please make sure you've set it up correctly on your exchange."
      ) {
        toastify("Please make sure you’re using the right keys.");
        return;
      }
      toastify(message);
    } catch (error) {
      toastify(error);
      console.error("🚀 -> connectManually -> error:", error);
    }
  };

  const handleClose = () => {
    if (onBoardingStartContext) {
      setShow(false);
      dispatch(resetOnBoardingStartContext());
      navigate(onBoardingStartContext, { replace: true });
      return;
    }
    navigate("/leader/dashboard", { replace: true });
    setShow(false);
  };

  const handleConnect = async () => {
    if (ENV !== "prod" && selectedOption.includes("Quick Connect")) {
      toastify("Quick Connect is not available in dev environment", "success");
      return;
    }
    if (useOldCredentials) {
      setIsLoading(true);
      try {
        const response = await api(
          "post",
          "multiCommunity/copyOtherCommunityCredentials",
          {
            ...useOldCredentials,
            verifymyTrade: window.location.pathname.includes("verifymyTrade"),
            fromOnBoarding: true,
          }
        );
        const { message, status } = response || {};

        if (status) {
          setIsConnected(true);
        //    await api(
        //   "post",
        //   "/binanceCredentials/setOnboardingFromTraderToCommunity",
        //   { onboarding:true }
        // );
          // dispatch(setRefetchSpecificUser(true));
          const responseUser = await api("get", "users/index");

          if (responseUser?.status) {
            const { data } = responseUser;
            if (dispatch && storeUser) dispatch(storeUser(data));
            if (data?.token) localStorage.setItem("token", data.token);
            // return data;
          }else{

            dispatch(setRefetchSpecificUser(true));
          }
          setIsLoading(false);
          setPreviousCredentials(false);
          return setTimeout(() => {
            setIsConnected(false);
            if (window.location.pathname.includes("verifymyTrade"))
              navigate("/leader/verifymyTrade/payment", { replace: true });
            else
              navigateAfterOnboardingConnection(
                useOldCredentials?.permissionType || tradeMarketType
              );
          //  return;
            }, 3000);
        }
        toastify(message);
        setIsLoading(false);
        setPreviousCredentials(false);
      } catch (error) {
        setIsLoading(false);
        setPreviousCredentials(false);
        toastify(error?.message || "An error occurred");
      }

      return;
    }
    if (
      (user?.binanceCredentials?.isConnected ||
        user?.bybitCredentials?.isConnected) &&
      credentials.apiKey.includes("*") &&
      credentials.secretKey.includes("*")
    ) {
      setIsLoading(true);
      // const response = await api(
      //   "post",
      //   "/binanceCredentials/communityCreateCredentials",
      //   { exchange: credentials.exchange }
      // );
      if (
        !user?.verifiedmyTrade.connecct &&
        location.pathname === "/leader/verifymyTrade/connection"
      ) {
        const response = await api("post", "/users/updateVerifMyTradeStatus", {
          status: true,
        });
      }
      if(!user?.onboarding?.connect&&location.pathname.includes("onboarding/connection")){
        await api(
          "post",
          "/binanceCredentials/setOnboardingFromTraderToCommunity",
          { onboarding:true }
        );
      }
      const responseUser = await api("get", "users/index");

        if (responseUser?.status) {
          const { data } = responseUser;
          if (dispatch && storeUser) dispatch(storeUser(data));
          if (data?.token) localStorage.setItem("token", data.token);
          // return data;
        }else{
          dispatch(setRefetchSpecificUser(true));
        }
      // dispatch(setRefetchSpecificUser(true));
      
     return setTimeout(() => {
      setIsLoading(false);
      if (window.location.pathname.includes("verifymyTrade"))
        navigate("/leader/verifymyTrade/payment", { replace: true });
      else navigateAfterOnboardingConnection(tradeMarketType);
     }, 3000);
    //  return;
    }

    setIsLoading(true);

    if (selectedOption.includes("Quick Connect")) {
      selectedOption.split(" ")[0] === "Binance"
        ? oAuthBinance()
        : oAuthBybit();
    } else if (credentials.apiKey && credentials.secretKey) {
      await connectManually(credentials);
    } else {
      const apiKeyMissing = !credentials.apiKey;
      const secretKeyMissing = !credentials.secretKey;

      setFormErrors({
        apiKey: apiKeyMissing,
        secretKey: secretKeyMissing,
      });

      if (apiKeyMissing && secretKeyMissing) {
        toastify("Both API Key and Secret Key are required", "error");
      } else if (apiKeyMissing) {
        toastify("API Key is required", "error");
      } else if (secretKeyMissing) {
        toastify("Secret Key is required", "error");
      }
    }

    setIsLoading(false);
  };
  useEffect(() => {
    if (previousCredentials) {
      handleConnect();
    }
  }, [previousCredentials]);
  const handleOptionSelection = (option) => {
    setCredentials((pre) => ({ ...pre, exchange: option.split(" ")[0] }));
    setisApiKeySelected(option.includes("API Keys"));
    setIsDropdownOpen(false);
    setSelectedOption(option);

    // const isBinanceConnected = user?.binanceCredentials?.isConnected;
    // const isBybitConnected = user?.bybitCredentials?.isConnected;

    // if (isBinanceConnected && option === "Binance API Keys") {
    //   setCredentials({
    //     apiKey: "****",
    //     secretKey: "****",
    //     exchange: "Binance",
    //   });
    // } else if (isBybitConnected && option === "ByBit API Keys") {
    //   setCredentials({
    //     apiKey: "****",
    //     secretKey: "****",
    //     exchange: "ByBit",
    //   });
    // } else {
    setCredentials((pre) => ({ ...pre, apiKey: "", secretKey: "" }));
    // }
  };

  const oAuthBinance = async () => {
    const userAgent = navigator.userAgent || "";
    const isSafariOnly =
      userAgent.includes("Safari") && !userAgent.includes("Chrome");

    setIsLoading(!isSafariOnly);
    redirectToBinanceOAuth({ permissionType: tradeMarketType, connectMode: true });
  };

  const oAuthBybit = async () => {
    const userAgent = navigator.userAgent || "";
    const isSafariOnly =
      userAgent.includes("Safari") && !userAgent.includes("Chrome");

    localStorage.setItem("binanceCondition", "true");
    setIsLoading(!isSafariOnly);
    redirectToBybitOAuth({ permissionType: tradeMarketType, connectMode: true });
  };

  const toggleDropdown = () => setIsDropdownOpen((pre) => !pre);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        buttonRef.current &&
        !buttonRef.current.contains(e.target) &&
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target)
      ) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  useEffect(() => {
    if (user && location.pathname === "/leader/onboarding/connection") {
      if (user?.binanceCredentials?.isConnected) {
        setSelectedOption("Binance API Keys");
        setisApiKeySelected(true);
        if (
          user?.binanceCredentials?.permissionType === "spot" ||
          user?.binanceCredentials?.permissionType === "futures" ||
          user?.binanceCredentials?.permissionType === "both"
        ) {
          setTradeMarketType(user.binanceCredentials.permissionType);
        }
        setCredentials({
          apiKey:
            "****************************************************************",
          secretKey:
            "****************************************************************",
          exchange: "Binance",
        });
      }
      if (user?.bybitCredentials?.isConnected) {
        setSelectedOption("ByBit API Keys");
        setisApiKeySelected(true);
        if (
          user?.bybitCredentials?.permissionType === "spot" ||
          user?.bybitCredentials?.permissionType === "futures" ||
          user?.bybitCredentials?.permissionType === "both"
        ) {
          setTradeMarketType(user.bybitCredentials.permissionType);
        }
        setCredentials({
          apiKey:
            "****************************************************************",
          secretKey:
            "****************************************************************",
          exchange: "ByBit",
        });
      }
    }
  }, [user]);

  useEffect(() => {
    const fetchOtherCommunitiesCredentials = async () => {
      try {
        const response = await api(
          "get",
          "multiCommunity/otherCommunitiesCredentials"
        );
        if (response?.status && Array.isArray(response.data)) {
          const matchedOption = response.data.find(
            (option) =>
              option.userid === user.previousCommunityUserId
          );

          if (matchedOption) {
            setPreviousCommunityConnected(true);
          }
          setOtherCommunityOptions(response.data);
        }
      } catch (error) {
        console.error("Error fetching other communities credentials:", error);
      }
    };
    fetchOtherCommunitiesCredentials();
  }, [allLeaderCommunities]);

  return (
    <div className="onboarding-modal-wrapper">
      <Modal
        animation={false}
        backdropClassName="onboarding-custom-backdrop"
        centered
        dialogClassName="custom-onboarding-modal connectExchnage"
        show={show}
      >
        <Modal.Body className="figma-drop-shadow connect-exchange-modal-body">
          {isConnected ? (
            <div className="connect-exchange-scroll">
              <ConnectedExchange />
            </div>
          ) : (
            <>
              <button
                className="reverseArrow"
                onClick={() => {
                  if (window.location.pathname.includes("verifymyTrade"))
                    navigate("/leader/verifymyTrade/tradeinfo", {
                      replace: true,
                    });
                  else
                    navigate("/leader/dashboard", {
                      replace: true,
                    });
                }}
                type="button"
              >
                <img src={longArrow} alt="" />
              </button>
              <button type="button" className="CrossIcon" onClick={handleClose}>
                <img src={crossBlack} alt="" />
              </button>
              <div className="connect-exchange-scroll" ref={modalBodyRef}>
              <div className="onboardingContentBox">
                <h2 className="title">
                  <span>Connect exchange account</span>
                  <InfoPopup
                    contentItems={[
                      { text: "Connect exchange", type: "heading" },
                      {
                        text: `${location.pathname.includes("onboarding")?"This is the trading account your members will copy trades from.<br>If you use an automated setup (e.g. signals), it must execute trades on this account.":"Turn this on to create a VIP subscription for your current lifetime(or just a longer access period) members at our cost price of $15/ month. If you define an end date for the VIP member then member will be offered to resubscribe at end of VIP membership. You can turn it off once you've onboarded all your VIP members without affecting their subscription."}`,
                        type: "paragraph",
                      },
                    ]}
                  />
                </h2>
                <p className="desc">
                  {/* {`Connect the exchange account to ${location.pathname==="/leader/verifymyTrade/connection"?"verify trades":"copy trade" } from`}
                   */}
                  {`${
                    location.pathname === "/leader/verifymyTrade/connection"
                      ? "Connect the exchange account to verify trades from"
                      : "This is the account your members will copy"
                  } `}
                </p>
                <div className="formBox">
                  <div className="mb-20px">
                    <div
                      className={`customDropdown onboardingInput onboardingDropdownContentWrap`}
                      ref={dropdownRef}
                    >
                      <button
                        className={`dropdownButton ${
                          selectedOption !== "Select Exchange"
                            ? "always_focused"
                            : ""
                        }`}
                        onClick={toggleDropdown}
                        ref={buttonRef}
                      >
                        <div className="inBtnFlexBox">
                          {selectedOption === "Select Exchange" ? (
                            selectedOption
                          ) : (
                            <>
                              {selectedOption.split(" ")[0]}
                              <span
                                className="text-truncate d-inline-block"
                                style={{ maxWidth: "150px" }}
                              >
                                ({selectedOption.split(" ").splice(1).join(" ")}
                                )
                              </span>
                            </>
                          )}
                        </div>
                        <span
                          className={`dropdownArrow ${
                            isDropdownOpen && "rotate"
                          }`}
                        >
                          <img alt="" src={dropdownAngle} />
                        </span>
                      </button>
                      {isDropdownOpen && (
                        <div className="dropdownContent">
                          <p
                            onClick={() =>
                              handleOptionSelection("Binance Quick Connect")
                            }
                          >
                            <span className="span1">Binance</span>
                            <span>Quick Connect</span>
                          </p>
                          <p
                            onClick={() =>
                              handleOptionSelection("Binance API Keys")
                            }
                          >
                            <span className="span1">Binance</span>
                            <span>API Keys</span>
                          </p>
                          <p
                            onClick={() =>
                              handleOptionSelection("ByBit Quick Connect")
                            }
                          >
                            <span className="span1">ByBit</span>
                            <span>Quick Connect</span>
                          </p>
                          <p
                            onClick={() =>
                              handleOptionSelection("ByBit API Keys")
                            }
                          >
                            <span className="span1">ByBit</span>
                            <span>API Keys</span>
                          </p>
                          {otherCommunityOptions.map((item, idx) => (
                            <p
                              key={idx}
                              onClick={() => {
                                setisApiKeySelected(false);
                                setIsDropdownOpen(false);
                                setSelectedOption(item.option);
                                setOldCredentials(item);
                              }}
                            >
                              <span className="span1">{item.exchange}</span>
                              <span
                                className="text-truncate d-inline-block"
                                style={{ maxWidth: "150px" }}
                              >
                                {item.option}
                              </span>
                            </p>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                  {isApiKeySelected && (
                    <>
                      <div className="mb-20px">
                        <FloatingTextFiled
                          className={`onboardingInput ${
                            formErrors.apiKey && "invalid"
                          }`}
                          label="API Key"
                          onChange={(e) =>
                            setCredentials((pre) => ({
                              ...pre,
                              apiKey: e.target.value,
                            }))
                          }
                          placeholder="API Key"
                          value={credentials.apiKey}
                        />
                      </div>
                      <div className="mb-20px">
                        <FloatingTextFiled
                          className={`onboardingInput ${
                            formErrors.secretKey && "invalid"
                          }`}
                          label="Secret Key"
                          onChange={(e) =>
                            setCredentials((pre) => ({
                              ...pre,
                              secretKey: e.target.value,
                            }))
                          }
                          placeholder="Secret Key"
                          value={credentials.secretKey}
                        />
                      </div>
                      {selectedOption === "Binance API Keys" && (
                        <div className="mb-20px copyIpBox">
                          <FloatingTextFiled
                            className="onboardingInput"
                            disabled={true}
                            forLabel="binanceIp"
                            id="binanceIp"
                            label="IP Address"
                            onChange={() => {}}
                            placeholder="IP"
                            value={
                              ENV === "prod" ? "108.129.27.187" : "52.214.92.9"
                            }
                            focusedAllowed={false}
                          />
                          <img
                            alt=""
                            className="copyIp"
                            onClick={() => {
                              navigator.clipboard
                                .writeText(
                                  ENV === "prod"
                                    ? "108.129.27.187"
                                    : "52.214.92.9"
                                )
                                .then(() => {
                                  toastify(
                                    "IP Address copied to clipboard!",
                                    "success"
                                  );
                                });
                            }}
                            src={Copy}
                          />
                        </div>
                      )}
                    </>
                  )}
                  {(isApiKeySelected ||
                    selectedOption.includes("Quick Connect")) && (
                    <div ref={tradeMarketRef} className="mb-20px">
                      <TradeMarketSegment
                        className="TradeMarketSegment--cm"
                        value={tradeMarketType}
                        onChange={setTradeMarketType}
                      />
                    </div>
                  )}
                  {selectedOption !== "Select Exchange" &&
                    !previousCredentials && (
                      <BubbleSvgButton
                        className="NextBtn"
                        onClick={handleConnect}
                        disabled={isLoading}
                        isLoading={isLoading}
                        text={
                          credentials?.apiKey?.includes("****") ||
                          credentials?.secretKey?.includes("****")
                            ? "Use Same API Keys"
                            : "NEXT"
                        }
                        type="button"
                        variant="black"
                        containerStyling={{
                          justifyContent: "center",
                        }}
                        mainDivStyle={{
                          width: "275px",
                          height: "55px",
                        }}
                      />
                    )}
                  {(isApiKeySelected ||
                    selectedOption.includes("Quick Connect")) && (
                    <div className="tradeMarketHintBelowNext">
                      <p className="subTitle">
                        Members will trade the same markets you enable.
                      </p>
                    </div>
                  )}
                  {((otherCommunityOptions?.length > 0 &&previousCommunityConnected&&
                    location.pathname === "/leader/onboarding/connection") ||
                    user?.bybitCredentials.isConnected ||
                    user?.binanceCredentials?.isConnected) &&
                    (selectedOption === "Select Exchange" || (isLoading && previousCredentials)) && (
                      <BubbleSvgButton
                        className="NextBtn"
                        onClick={() => {
                          // setisApiKeySelected(false);
                          // setIsDropdownOpen(false);

                          if (
                            location.pathname ===
                              "/leader/verifymyTrade/connection" &&
                            !user?.leaderCommunity
                          ) {
                            navigate("/leader/verifymyTrade/payment", {
                              replace: true,
                            });

                            return;
                          } else if (
                            user?.leaderCommunity &&
                            location.pathname ===
                              "/leader/verifymyTrade/connection" &&
                            (user?.binanceCredentials.isConnected ||
                              user?.bybitCredentials?.isConnected)&& !user?.verifiedmyTrade.connecct
                          ) {
                            setUpdateVerifyStatus(true);
                            return;
                          }
                          const matchedOption = otherCommunityOptions.find(
                            (option) =>
                              option.userid === user.previousCommunityUserId
                          );

                          if (matchedOption) {
                            setIsLoading(true);
                            setSelectedOption(matchedOption.option);
                            setOldCredentials(matchedOption);
                          }
                          setPreviousCredentials(true);
                        }}
                        disabled={isLoading}
                        isLoading={isLoading}
                        text={"Use Same API Keys"}
                        type="button"
                        variant="black"
                        containerStyling={{
                          justifyContent: "center",
                        }}
                        mainDivStyle={{
                          width: "275px",
                          height: "55px",
                        }}
                      />
                    )}
                </div>
              </div>
              </div>
              {location.pathname === "/leader/onboarding/connection" ? (
                <div className="paginationDots">
                  <button className="dot"></button>
                  <button className="dot active"></button>
                  <button className="dot"></button>
                  <button className="dot"></button>
                  <button className="dot"></button>
                  <button className="dot"></button>
                  <button className="dot"></button>
                  <button className="dot"></button>
                </div>
              ) : (
                <div className="paginationDots">
                  <button className="dot"></button>
                  <button className="dot active"></button>
                  <button className="dot"></button>
                  {/* <button className="dot"></button>
                 <button className="dot"></button>
                 <button className="dot"></button>
                 <button className="dot"></button> */}
                </div>
              )}
              {/* <div className="copyrightBox">
                <p className="">
                  Powered by
                  <span className="spanMain">
                    <img alt="" src={logo_black} />
                  </span>
                </p>
              </div> */}
            </>
          )}
        </Modal.Body>
      </Modal>

      {warn && (
        <CloseModal handleClose={handleClose} setWarn={setWarn} warn={warn} />
      )}
    </div>
  );
};

export default ConnectExchange;
